import { FuseNavigationModelInterface } from '../core/components/navigation/navigation.model';

export class FuseNavigationModel implements FuseNavigationModelInterface {
    public model: any[];

    constructor() {
        this.model = [
            {
                'id': 'applications',
                'title': 'Applications',
                'translate': 'NAV.APPLICATIONS',
                'type': 'group',
                'children': [
                    {
                        'id': 'sample',
                        'title': 'Sample',
                        'translate': 'NAV.SAMPLE.TITLE',
                        // 'type': 'item',
                        'icon': 'email',
                        'url': '/sample',
                        'badge': {
                            'title': 25,
                            'translate': 'NAV.SAMPLE.BADGE',
                            'bg': '#F44336',
                            'fg': '#FFFFFF'
                        }
                    },
                    {
                        'id': 'login',
                        'title': 'Login',
                        'translate': 'NAV.LOGIN.TITLE',
                        'icon': 'email',
                        'url': '/login',
                    },
                    {
                        'id': 'inspection',
                        'title': 'InspectionReport',
                        'translate': 'NAV.INSPETIONREPORT.TITLE',
                        'icon': 'picture_as_pdf',
                        'type': 'item',
                        'url': '/inspection/main'
                    },

                    /** Logout button */
                    {
                        'id': 'logout',
                        'type': 'item',
                    }
                ]
            }
        ];
    }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/navigation/navigation.model.ts